import React from 'react'

function LatestMatch() {
  return (
    <section className="latest-match-area latest-match-bg pt-115 pb-90">
      <div className="container">
        <div className="row justify-content-center">
          <div className="col-xl-6 col-lg-8">
            <div className="section-title title-style-three white-title md-text-center mb-70">
              <h2>Why Choose <span>Us?</span></h2>
            </div>
          </div>
        </div>
        <div className="row">

          <div className="col-lg-6">
            <div className="latest-match-box mb-30">
              <div className="latest-match-thumb">
                <img
                  style={{
                    maxHeight: "200px",
                    width: "auto",
                    objectFit: "contain",
                  }}
                  src="assets/img/images/Liveplay - Immersive content.png" alt="" />
              </div>
              <div className="tournament-schedule-content">
                <h3 className='md-text-center' >Immersive    <span>  Content</span> </h3>
                <p className='md-text-center' >
                  Dive into engaging content experiences featuring jigsaws, Pictionary challenges,
                  multimedia, number, word, and game competitions. Choose from over 150 captivating themes,
                  including movies, sports, travel, food, arcade games, puzzles, action, and much more.
                </p>
              </div>
            </div>
          </div>

          <div className="col-lg-6">
            <div className="latest-match-box mb-30">
              <div className="latest-match-thumb">
                <img
                  style={{
                    maxHeight: "200px",
                    width: "auto",
                    objectFit: "contain",
                  }}
                  src="assets/img/images/Liveplay - Engaging desig.png" alt="" />
              </div>
              <div className="tournament-schedule-content">
                <h3 className='md-text-center' >Engaging <span>Design</span> </h3>
                <p className='md-text-center' >
                  Experience open challenges, tournaments, one-on-one battles, and group play formats for both
                  games and trivia, ensuring a dynamic gaming experience.
                </p>
              </div>
            </div>
          </div>

          <div className="col-lg-6">
            <div className="latest-match-box mb-30">
              <div className="latest-match-thumb">
                <img
                  style={{
                    maxHeight: "200px",
                    width: "auto",
                    objectFit: "contain",
                  }}
                  src="assets/img/images/Liveplay - Multiplayer gaming.png" alt="" />
              </div>
              <div className="tournament-schedule-content">
                <h3 className='md-text-center' >Multiplayer  <span> Gaming</span> </h3>
                <p className='md-text-center' >
                  Compete with friends in quizzes, puzzles, trivia, and casual games — all in one place! Enjoy real-time fun with video/audio chat and earn exciting rewards by inviting friends.
                </p>
              </div>
            </div>
          </div>

          <div className="col-lg-6">
            <div className="latest-match-box mb-30">
              <div className="latest-match-thumb">
                <img
                  style={{
                    maxHeight: "200px",
                    width: "auto",
                    objectFit: "contain",
                  }}
                  src="assets/img/images/Liveplay - Leader board.png" alt="" />
              </div>
              <div className="tournament-schedule-content">
                <h3 className='md-text-center' >Real-Time <span>Leaderboard</span> </h3>
                <p className='md-text-center' >
                  Experience instant ranking on the leaderboard, where your position is determined by time-based
                  scores. Users can engage in skill-based competitions that motivate them to climb to the top of
                  the leaderboard and showcase their abilities.
                </p>
              </div>
            </div>
          </div>

        </div>
      </div>
    </section>
  )
}

export default LatestMatch
